import { useFlag } from '@unleash/proxy-client-vue'

export const useFeatureFlags = () => {
  const isDietSettingsAnnouncementEnabled = useFlag('badges.new.diet-settings')

  const isCommonAnnouncementEnabled = useFlag('app.common-announcement')

  return {
    isDietSettingsAnnouncementEnabled,
    isCommonAnnouncementEnabled,
  }
}
